import React from 'react';
import OurPartners from "../../../components/sections/front/Common/OurPartners";
import SectionBlogDetails from "../../../components/sections/front/Blogs/SectionBlogDetails";

const BlogDetails = () => {
  
  return (
    <>
      <SectionBlogDetails/>
      <OurPartners />
    </>
  );
};

export default BlogDetails;